import AccountsContext from "app/contexts/app/AccountsContext";
import { useContext } from "react";

const useAccounts = () => useContext(AccountsContext);

export default useAccounts;
